import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  Title,
  Mark,
  PicPivot,
  PicHolder
} from "./VisionariesSlide2.style"

import MarkIcon from "./mark.svg"

export default function VisionariesSlide2() {
  return (
    <Holder>
      <PicPivot>
        <PicHolder>
          <Pic src="/assets/textures/gallery/coronation_square/img-1b.jpg" />
          <Overlay>
            <Caption>
              <Title>
                Pollard Thomas Edwards – <br />
                Planning Architect
              </Title>
              <Text>
                Pollard Thomas Edwards is an architecture practice specialising
                in the design of homes, neighbourhoods, public and mixed-use
                buildings throughout the United Kingdom.
              </Text>
              <Text>
                Over the past five decades they have built up an enviable
                track-record working with communities, local authorities and
                commercial clients to create buildings and places people want to
                live in.
              </Text>
              <Text>
                Using the full range of skills at their disposal, from
                architectural and urban design to masterplanning, property
                development and community engagement, their team of 150-plus
                professionals are dedicated to enhancing the towns, cities and
                villages in which we work.
              </Text>
              <Mark src={MarkIcon}></Mark>
            </Caption>
          </Overlay>
        </PicHolder>
      </PicPivot>
    </Holder>
  )
}
